import { createAsyncAction } from 'typesafe-actions';
import { IdType } from '@rootCommon/types/common';
import { FhqHelpContact, FhqHelpContactCreateDto, FhqHelpContactUpdateDto } from '@rootCommon/types/fhq';

export const fetchFhqHelpContacts = createAsyncAction(
  'FETCH_HELP_CONTACTS_REQUEST',
  'FETCH_HELP_CONTACTS_SUCCESS',
  'FETCH_HELP_CONTACTS_FAILURE',
)
<IdType, { siteFhqId: IdType; items: FhqHelpContact[] }, Error>();

export const createFhqHelpContact = createAsyncAction(
  'CREATE_HELP_CONTACT_REQUEST',
  'CREATE_HELP_CONTACT_SUCCESS',
  'CREATE_HELP_CONTACT_FAILURE',
)
<FhqHelpContactCreateDto, { siteFhqId: IdType; data: FhqHelpContact }, Error>();

export const updateFhqHelpContact = createAsyncAction(
  'UPDATE_HELP_CONTACT_REQUEST',
  'UPDATE_HELP_CONTACT_SUCCESS',
  'UPDATE_HELP_CONTACT_FAILURE',
)
<{ siteFhqId: IdType; id: IdType; data: FhqHelpContactUpdateDto },
{ siteFhqId: IdType; data: FhqHelpContact }, Error>();

export const deleteFhqHelpContact = createAsyncAction(
  'DELETE_HELP_CONTACT_REQUEST',
  'DELETE_HELP_CONTACT_SUCCESS',
  'DELETE_HELP_CONTACT_FAILURE',
)
<IdType, IdType, Error>();
